import { usePermissions } from '@/composables/usePermissions';
import { t } from '@/i18n';
import AppMessages from '@/models/core/AppMessages';
import { useSessionStore } from '@/stores/session';
import Permissions from '@/constants/Permissions';

/**
 * Route guard that checks if user has required permissions
 */
export function requirePermissions(permissions: string[]) {
  return () => {
    const sessionStore = useSessionStore();
    const { hasAnyPermission } = usePermissions();

    // Check if user is authenticated
    if (!sessionStore.isAuthenticated || !hasAnyPermission(permissions)) {
      // Redirect to login or handle unauthenticated user
      AppMessages.error(t('errors.UNAUTHORIZED'));
      return false;
    }
  };
}

/**
 * Route guard that requires employee management permissions
 */
export function requireEmployeeManagement() {
  return requirePermissions([Permissions.Employee.Create, Permissions.Employee.Update]);
}
